import { useMutation } from '@tanstack/react-query';

import { exportOfferAsPdf } from '../../../../common/api/clients/export.api';

export const useExportOfferMutation = () => {
    return useMutation({ mutationFn: exportOfferAsPdf });
};
